import { socketService } from '@aqx-core/common/socket';
import { IDOMTopicMessage } from '@aqx-core/common/socket/topics/dom';

class DOMTopicSubscription {
  public subscribe = (
    symbol: string,
    subscriptionKey: string,
    updateDOMData: (payload: IDOMTopicMessage | undefined) => void
  ) => {
    socketService.topics().dom.subscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload) => updateDOMData(payload)
      }
    });
  };

  public unsubscribe = (
    symbol: string,
    subscriptionKey: string,
    updateDOMData: (payload: IDOMTopicMessage | undefined) => void
  ) => {
    socketService.topics().dom.unsubscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload) => updateDOMData(payload)
      }
    });
  };
}

export const domTopicSubscription = new DOMTopicSubscription();
